import { render } from "./LivraisonClinique.vue?vue&type=template&id=12fdb9f6&scoped=true"
import script from "./LivraisonClinique.vue?vue&type=script&lang=js"
export * from "./LivraisonClinique.vue?vue&type=script&lang=js"

import "./LivraisonClinique.vue?vue&type=style&index=0&id=12fdb9f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12fdb9f6"]])

export default __exports__